module.exports = __webpack_public_path__ + "b0935779baab3d1f682d45c898179dfe.mp4";


//////////////////
// WEBPACK FOOTER
// ./web/images/endless_possibilities/videos_on_demand.mp4
// module id = 590
// module chunks = 0